import React from 'react';
import { FiAlertTriangle } from 'react-icons/fi';
import i18n from '../../i18n';
import './SystemState.css';

// Catches render errors in whatever it wraps so one broken page shows a fallback
// instead of white-screening the whole app. Must be a class component - React has
// no hook equivalent for getDerivedStateFromError/componentDidCatch.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Unhandled render error:', error, info?.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="system-state">
        <div className="system-state-icon-badge system-state-icon-badge--red">
          <FiAlertTriangle size={24} />
        </div>
        <h2 className="system-state-title">{i18n.t('systemState:errorTitle')}</h2>
        <p className="system-state-desc">{i18n.t('systemState:errorDesc')}</p>
        <div className="system-state-actions">
          <button className="system-state-btn-primary" onClick={() => window.location.reload()}>
            {i18n.t('systemState:reloadPage')}
          </button>
          <button className="system-state-btn-ghost" onClick={() => window.location.assign('/')}>
            {i18n.t('systemState:goToFrontpage')}
          </button>
        </div>
      </div>
    );
  }
}
